import { apiFetch } from "@/lib/api";

/** Matches `registerClampQcInspectionExistsRoutes` JSON body. Operator text is trimmed and truncated server-side. */
export type ClampQcInspectionExistsResponse =
  | { exists: false }
  | {
      exists: true;
      recordedForBuildOrderId: number | null;
      recordedWorkOrderLabel: string | null;
      recordedPurchaseOrderNumber: string | null;
      sgsQcAtIso: string | null;
      sku: string | null;
      inspectionResult: "Passed" | "Failed" | null;
    };

export async function fetchClampQcInspectionExists(serialTextOperatorsEntry: string): Promise<ClampQcInspectionExistsResponse> {
  return apiFetch<ClampQcInspectionExistsResponse>("/api/clamp-qc/inspection-exists", {
    method: "POST",
    body: { serialText: serialTextOperatorsEntry },
  });
}
